module.exports = __webpack_public_path__ + "static/media/comment-new.e99143ed.svg";